import { Button, Input, Select } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  checkValidEngNumbers,
  convertParamsIdToNumber,
  onChangeProvince,
} from "../../../core/utils";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import FilterLayout from "../../../components/FilterLayout/FilterLayout";
import RangePicker from "../../../components/RangePicker/RangePicker";
import { useHistory } from "react-router-dom";

const FilterDrivers = ({
  filters,
  onChangeFilters,
  onFilterDrivers,
  getDriversReport,
}) => {
  const store = useSelector((state) => state.Store);
  const history = useHistory();
  const [cities, setCities] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const { Option } = Select;
  return (
    <FilterLayout
      search={filters.search || ""}
      setSearch={(value) => onChangeFilters({ search: value })}
      onSearch={onFilterDrivers}
      reportFilter={getDriversReport}
      placeHolder="Search with driver name or mobile number or plate number"
      isVisible={isVisible}
      setIsVisible={setIsVisible}
    >
      <FormWrapper>
        <Select
          className="border-black-8 mb-10 input-size"
          showSearch
          placeholder={"Province"}
          value={convertParamsIdToNumber(filters.province_id)}
          onChange={(value) =>
            onChangeProvince(
              value,
              () => onChangeFilters({ province_id: value, city_id: null }),
              setCities
            )
          }
        >
          <Option value={null} name="All Provinces">
            All Provinces
          </Option>
          {store.provinces.map((province) => {
            return (
              <Option value={province.id} key={province.id}>
                {province.name}
              </Option>
            );
          })}
        </Select>
        <Select
          className="border-black-8 mb-10 input-size"
          showSearch
          placeholder={"City"}
          value={convertParamsIdToNumber(filters.city_id)}
          onChange={(value) => onChangeFilters({ city_id: value })}
          disabled={!filters.province_id}
        >
          <Option value={null} name="All Cities">
            All Cities
          </Option>
          {cities.map((city) => {
            return (
              <Option value={city.id} key={city.id}>
                {city.name}
              </Option>
            );
          })}
        </Select>
        <Input
          className="input-black border-black-8 mb-10 input-size"
          placeholder="First Name"
          value={filters.first_name}
          onChange={(e) => onChangeFilters({ first_name: e.target.value })}
        />
        <Input
          className="input-black border-black-8 mb-10 input-size"
          placeholder="Last Name"
          value={filters.last_name}
          onChange={(e) => onChangeFilters({ last_name: e.target.value })}
        />
        <Input
          className="input-black border-black-8 mb-10 input-size"
          placeholder="Mobile Number"
          value={filters.username}
          onChange={(e) => onChangeFilters({ username: e.target.value })}
          onKeyDown={checkValidEngNumbers}
          maxLength={11}
        />
        <Input
          className="input-black border-black-8 mb-10 input-size"
          placeholder="National ID"
          value={filters.national_id}
          onChange={(e) => onChangeFilters({ national_id: e.target.value })}
          onKeyDown={checkValidEngNumbers}
          maxLength={10}
        />
        <RangePicker
          className="border-black-8 h-45px input-size border-radius-main"
          currentRange={filters.created_date}
          onGetRange={(value) => onChangeFilters({ created_date: value })}
        />
        <div className="w-100" />
        <Button
          className="button-red input-size sm:w-100 "
          onClick={() => {
            history.push(window.location.pathname);
            setIsVisible(false);
            setTimeout(() => {
              onChangeFilters({
                province_id: null,
                city_id: null,
                first_name: "",
                last_name: "",
                username: "",
                search: "",
              });
              onFilterDrivers(null, true);
            }, 100);
          }}
        >
          Reset Filters
        </Button>
        <Button
          className="button-secondary input-size sm:w-100 "
          onClick={() => {
            onFilterDrivers();
            setIsVisible(false);
          }}
        >
          Filter
        </Button>
      </FormWrapper>
    </FilterLayout>
  );
};

export default FilterDrivers;
